<template>
  <v-data-iterator :items="integrations" :items-per-page="20" :loading="loading" style="width: 100%;" return-object>
    <template v-slot:loader>
      <v-row class="mt-6"><v-col class="text-center"><v-progress-circular indeterminate size="70" width="7" color="primary" :aria-label="$t('routes.webhookIntegrations.loadingList')" /><div>{{ $t('routes.webhookIntegrations.loadingList') }}</div></v-col></v-row>
    </template>
    <template v-slot:no-data>
      <v-row class="mt-6"><v-col class="text-center">{{ $t('routes.webhookIntegrations.noIntegrationsFound') }}</v-col></v-row>
    </template>
    <template v-slot:header>
      <div class="d-flex webhook-integration-row webhook-integrations-header-row">
        <div>{{ $t('routes.webhookIntegrations.name') }}</div>
        <div>{{ $t('routes.webhookIntegrations.type') }}</div>
        <div>{{ $t('routes.webhookIntegrations.status') }}</div>
        <div>{{ $t('routes.webhookIntegrations.createdAt') }}</div>
        <div></div>
      </div>
    </template>
    <template v-slot:default="{ items }">
      <div class="mt-2">
        <WebhookIntegrationItem
          v-for="item in items"
          :key="item.value.id"
          :integration="item.value"
          :integration-types="integrationTypes"
          class="webhook-integration-row"
          @edit="$emit('edit', $event)"
          @delete="$emit('delete', $event)"
          @state="$emit('state', $event)"
          @view="$emit('view', $event)"
        />
      </div>
    </template>
  </v-data-iterator>
</template>

<script>
import WebhookIntegrationItem from './WebhookIntegrationItem.vue';

export default {
  name: 'WebhookIntegrationsListView',
  components: { WebhookIntegrationItem },
  props: {
    integrations: { type: Array, required: true },
    integrationTypes: { type: Array, required: true },
    loading: { type: Boolean, required: true },
  },
  emits: ['edit', 'delete', 'state', 'view'],
}
</script>

<style lang="scss">
.webhook-integrations-header-row {
  font-weight: 600;
  min-height: 54px;
  color: #000000;
  background-color: #3dabff;
  border-radius: 10px;
  align-items: center;
}

.webhook-integration-row {
  padding-left: 8px;
  padding-right: 8px;
}

.webhook-integration-row > div {
  display: flex;
  align-items: center;
  word-break: normal;
}

.webhook-integration-row > div:nth-child(1) { width: 36%; }
.webhook-integration-row > div:nth-child(2) { width: 18%; }
.webhook-integration-row > div:nth-child(3) { width: 16%; }
.webhook-integration-row > div:nth-child(4) { width: 20%; }
.webhook-integration-row > div:nth-child(5) { width: 10%; justify-content: end; }

@media only screen and (max-width: 960px) {
  .webhook-integration-row > div:nth-child(1) { width: 45%; }
  .webhook-integration-row > div:nth-child(2) { display: none; }
  .webhook-integration-row > div:nth-child(3) { width: 25%; }
  .webhook-integration-row > div:nth-child(4) { display: none; }
  .webhook-integration-row > div:nth-child(5) { display: none; }
  .webhook-integration-row > div:nth-child(6) { width: 30%; }
}
</style>
